import { useEffect, useState } from "react";

/**
 * AuraBackground — два orange-кружка з b0a8901 архітектури.
 *
 * Single source of truth для warm aura background. Раніше aura жила
 * тільки в Layout, але Onboarding flow і OnboardingGate знаходяться
 * ПОЗА Layout → не мали aura → виглядали як «голий beige».
 *
 * Юзер 2026-05-24: «налаштуй сфери / збираю добірку / готово — фон
 * одноколірний бежевий без оранжевого свечення».
 *
 * Використання:
 *   <AuraBackground />
 *   <ваш контент>
 *
 * Aura використовує `position: fixed` — буде на місці при скролі.
 * `pointer-events: none` — не перехоплює тапи.
 */

export function AuraBackground() {
  // iOS: коли відкривається клавіатура, visual viewport зсувається, і `fixed`
  // елементи «стрибають» угору разом із ним — власник 2026-08-11 бачив це як
  // «фон рухається і блік піднімається» при тапі в поле вводу. Компенсуємо
  // зсув: тримаємо ауру на місці відносно того, що людина бачить.
  const [shift, setShift] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onChange = () => setShift(vv.offsetTop);
    vv.addEventListener("resize", onChange);
    vv.addEventListener("scroll", onChange);
    return () => {
      vv.removeEventListener("resize", onChange);
      vv.removeEventListener("scroll", onChange);
    };
  }, []);
  const shiftStyle = shift
    ? { transform: `translate3d(0, ${shift}px, 0)` }
    : undefined;

  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none fixed -left-20 -top-32 h-[23.75rem] w-[23.75rem]"
        style={{
          zIndex: 0,
          background:
            "radial-gradient(circle, rgba(255,161,53,0.38) 0%, rgba(255,161,53,0) 60%)",
          ...shiftStyle,
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none fixed -right-24 top-[40%] h-[17.5rem] w-[17.5rem]"
        style={{
          zIndex: 0,
          background:
            "radial-gradient(circle, rgba(255,107,4,0.22) 0%, rgba(255,107,4,0) 65%)",
          ...shiftStyle,
        }}
      />
    </>
  );
}
